



















































import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import { IImageMultipleCreateRequest } from "@/types/image";
import { IStageListRequest } from "@/types/stage";
import { ISelectItem } from "@/types";
import { IUser } from "@/types/user";

@Component({
  components: {}
})
export default class extends Vue {
  @Action("image/adminMultipleCreate")
  public multipleCreate!: (
    data: IImageMultipleCreateRequest
  ) => Promise<boolean>;

  @Mutation("image/clear")
  public clear!: () => void;

  @Action("stage/getList")
  public getStages!: (params: IStageListRequest) => Promise<boolean>;

  @Getter("stage/selectItem")
  public stages!: ISelectItem[];

  @Getter("auth/me")
  public user!: IUser;

  public rules = {
    file: [
      (files: File[]) =>
        !files ||
        files.length <= 0 ||
        files.reduce((sum, file) => sum + file.size, 0) <
          15 * 1024 * 1024 * 1024 ||
        "写真は合計15GBまでです"
    ],
    memo: [
      (v: string) =>
        !v || v.length <= 50 || "メモは50文字以下で入力してください"
    ]
  };

  public valid = true;
  public lazy = false;
  public dialog = false;
  public params: IImageMultipleCreateRequest = {
    site_id: 0,
    is_published: false,
    upload_file: [],
    memo: "",
    stage_id: 0
  };

  //--------
  // コンポーネント作成時実行
  public async created() {
    this.params.site_id = Number(this.$route.params.site_id);
    this.clear();

    await this.getStages({ company_id: this.user.company_id });
  }

  //--------
  // ファイルが選択されたときの挙動
  public fileChanged(event: Event) {
    const $file = event.target as HTMLInputElement;
    const files = $file.files || [];
    if (files?.length === 0) {
      return;
    }

    Array.from(files).forEach((file: File) => {
      if (!/^image/.test(file.type)) {
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onloadend = () => {
        this.params.upload_file?.push(reader.result as string);
      };
    });
  }
  //--------
  // 確定ボタンが押された際の挙動
  public async submit() {
    let result = false;
    result = await this.multipleCreate(this.params);
    if (result) {
      this.$router.go(-1);
    }
  }
}
